import { useEffect, useRef } from 'react'

type CallbackType = () => void
type DelayType = number | null
type FuncType = (handler: CallbackType, timeout?: number) => number
type ClearFuncType = (handle: number) => void

const createScheduling =
  (func: FuncType, clearFunc: ClearFuncType) =>
    (callback: CallbackType, delay: DelayType) => {
      const savedCallback = useRef<CallbackType>(callback)
      const timerId = useRef<number>()

      useEffect(() => {
        savedCallback.current = callback
      }, [callback])

      useEffect(() => {
        if (delay !== null) {
          timerId.current = func(() => {
            savedCallback.current()
          }, delay)
        }
      }, [delay])

      useEffect(
        () => () => {
          if (timerId.current) {
            clearFunc(timerId.current)
          }
        },
        [],
      )

      return () => {
        if (timerId.current) {
          clearFunc(timerId.current)
          if (delay) {
            timerId.current = func(() => savedCallback.current(), delay)
          }
        }
      }
    }

export const useInterval = createScheduling(setInterval, clearInterval)
export const useTimeout = createScheduling(setTimeout, clearTimeout)
